import { render } from "./Mini.vue?vue&type=template&id=3519ad68"
import script from "./Mini.vue?vue&type=script&lang=js"
export * from "./Mini.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__